export const ProjectPhase = Object.freeze({
    IN_PROGRESS: "inProgress",
    PUSHED_TO_LEGACY: "pushedToLegacy",
    PUBLISHED_TO_LEGACY: "publishedToLegacy",
})

export function isLockedToLegacy(phase) {
    return phase === ProjectPhase.PUSHED_TO_LEGACY || phase === ProjectPhase.PUBLISHED_TO_LEGACY
}
